<template>
<div>
  <div class="bg-primary-lightest py-10">
    <div class="static-container text-center sm:text-left">
      <h2 class="text-3xl sm:text-6xl font-bold">
        {{ headerTitle }}
      </h2>
      <p class="text-grey-darkest mt-3 mx-auto text-base sm:mt-4">
        <router-link :to="{ name: 'offers-list' }" class="underline">&larr; К списку акций</router-link>
      </p>
    </div>
  </div>

  <div class="static-container mt-10">
    <responsive-image v-if="hasHeaderCover"
                      class="px-4 sm:px-0 rounded-lg w-full h-full object-cover my-4"
                      :media="article.cover"
                      :sizes="['hd', 'large', 'medium']"
    />

    <div class="prose mb-4 max-w-full px-4 sm:px-0" v-html="articleBody"></div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import HasOfferArticle from '@/components/offers/HasOfferArticle'
import ResponsiveImage from '@/components/images/ResponsiveImage'
import InjectsSeo from '@/mixins/InjectsSeo'

export default {
  mixins: [HasOfferArticle, InjectsSeo],

  props: {
    shortId: {
      required: true,
      type: String,
    },
    slug: {
      required: true,
      type: String,
    },
  },

  components: {
    ResponsiveImage,
  },

  metaInfo() {
    if (!this.offerIsReady) {
      return this.getMetaInfoFromSettings(this.offersSeo)
    }

    return {
      title: this.getFullPageTitle(this.title),
      meta: [
        { name: 'description', content: this.intro },
      ],
    }
  },

  computed: {
    ...mapGetters({
      offers: 'offers/offers',
      offersLoaded: 'offers/loaded',
      settings: 'settings/offerPage',
      offersSeo: 'settings/offersSeo',
    }),

    offerIsReady() {
      return !!this.offer && !!this.offer.id
    },

    offer() {
      if (!this.offersLoaded) {
        return null
      }

      return this.offers.find(offer => offer.short_id === this.shortId)
    },

    hasHeaderCover() {
      if (this.settings.display_cover === 'never') {
        return false
      } else if (this.offersLoaded) {
        return this.hasCover
      }

      return false
    },

    headerTitle() {
      if (this.offersLoaded) {
        return this.title
      }

      return ''
    },

    articleBody() {
      if (this.offersLoaded && this.article.body) {
        return this.article.body
      }

      return ''
    },
  },
}
</script>
